import {Component, ElementRef, inject, Input, OnInit, ViewChild} from "@angular/core";
import {BreadcrumbItem} from "../../../models/BreadcrumbItem";
import {ResourceRequest, ResourceRequestOverviewDTO} from "../../../models/resource-request";
import {ResourceRequestListService} from "../../../../feature/resource-request-list/services/resource-request-list.service";
import {ActivatedRoute, Router} from "@angular/router";
import {DataService} from "../../../services/services/data.service";
import {AddResourceRequestComponent} from "../../../../feature/resource-request-list/components/add-resource-request/add-resource-request.component";
import {MatFormField, MatSuffix} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatAutocompleteTrigger} from "@angular/material/autocomplete";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {ResourceRequestAutocompleteComponent} from "../../../../shared/autocomplete/components/resource-request-autocomplete.component";

@Component({
	selector: "app-breadcrumb-resource-request-search",
	templateUrl: "./breadcrumb-resource-request-search.component.html",
	styleUrls: ["./breadcrumb-resource-request-search.component.scss"],
	imports: [
		MatFormField,
		MatInput,
		MatAutocompleteTrigger,
		MatIconButton,
		MatSuffix,
		MatIcon,
		ResourceRequestAutocompleteComponent,
	],
})
export class BreadcrumbResourceRequestSearchComponent implements OnInit {
	@Input() breadcrumb: BreadcrumbItem;
	currentResourceRequest: ResourceRequestOverviewDTO;
	readonly detailPath: string = "/resource-request-list/";

	@ViewChild("resourceRequestInput") resourceRequestInput: ElementRef;

	private readonly _route = inject(ActivatedRoute);
	private readonly _requestService = inject(ResourceRequestListService);
	private readonly _router = inject(Router);
	private readonly _dataService = inject(DataService);
	private readonly _addResourceRequestComponent = inject(AddResourceRequestComponent);

	private static mapToResourceRequestOverviewDTO(resourceRequest: ResourceRequest): ResourceRequestOverviewDTO {
		const resourceRequestOverviewDTO = new ResourceRequestOverviewDTO();
		Object.assign(resourceRequestOverviewDTO, resourceRequest);
		return resourceRequestOverviewDTO;
	}

	ngOnInit(): void {
		this._dataService.currentResourceRequest.subscribe((currentRequest) => {
			const subPath = this.breadcrumb.path.substring(
				this.breadcrumb.path.lastIndexOf(this.detailPath) + this.detailPath.length,
			);
			const sharePointId = subPath.lastIndexOf("/") > 0 ? subPath.substring(0, subPath.lastIndexOf("/")) : subPath;
			const instance = subPath.lastIndexOf("/") > 0 ? subPath.substring(subPath.lastIndexOf("/") + 1) : "";
			if (currentRequest && currentRequest.id.toString() === sharePointId) {
				this.currentResourceRequest = currentRequest;
			} else if (instance === "") {
				this._requestService
					.getById(Number.parseInt(sharePointId, 10))
					.subscribe(
						(r) =>
							(this.currentResourceRequest =
								BreadcrumbResourceRequestSearchComponent.mapToResourceRequestOverviewDTO(r)),
					);
			} else {
				this._requestService
					.getGlobalById(Number.parseInt(sharePointId, 10), instance)
					.subscribe(
						(r) =>
							(this.currentResourceRequest =
								BreadcrumbResourceRequestSearchComponent.mapToResourceRequestOverviewDTO(r)),
					);
			}
		});
	}

	onItemChange(resourceRequest: ResourceRequestOverviewDTO) {
		this._dataService.changeResourceRequest(resourceRequest);
		this._router.navigate([this.detailPath + resourceRequest.id]).then();
		this._router.routeReuseStrategy.shouldReuseRoute = () => false;
	}

	onClear() {
		this.resourceRequestInput.nativeElement.value = "";
	}

	onLeaveText() {
		// deferred so a click on an autocomplete option (which blurs the input first) is processed before we reset the value
		setTimeout(() => {
			this.resourceRequestInput.nativeElement.value = this.getCurrentResourceRequestText();
		});
	}

	getCurrentResourceRequestText(): string {
		if (this.currentResourceRequest.client) {
			return this.currentResourceRequest.client + " - " + this.currentResourceRequest.requestTitle;
		} else {
			return this.currentResourceRequest.requestTitle;
		}
	}
}
